'use client'

import { createContext, useState, useCallback, ReactNode, FC } from 'react'
import { NotificationState, NotificationContextType, NotificationType } from './types'

const initialState: NotificationState = {
  isVisible: false,
  message: '',
  duration: 6000,
  type: NotificationType.SUCCESS,
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

export const NotificationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [notification, setNotification] = useState<NotificationState>(initialState)

  const openNotification = useCallback((message: string, type: NotificationType) => {
    setNotification({
      isVisible: true,
      message,
      type,
      duration: 6000,
    })
  }, [])

  const closeNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, isVisible: false }))
  }, [])

  return (
    <NotificationContext.Provider value={{ notification, openNotification, closeNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}
